import React from 'react';
import ErrorPage from 'shared/pages/Error';

function Custom404() {
  return <ErrorPage status={404} />;
}

export default Custom404;
